import { PERCENT_TITLE_STEPS } from './constants';

export const getTitleByPercent = (percent: number): string => {
  const step = PERCENT_TITLE_STEPS.find((s) => percent <= s.upTo);

  return step?.title ?? PERCENT_TITLE_STEPS[PERCENT_TITLE_STEPS.length - 1].title;
};
